(() => {

  function escapeHTML(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function initBulkOrder() {

    document
      .querySelectorAll('.eg-variant-picker')
      .forEach((picker) => {

        if (picker.dataset.egBulkReady === 'true') return;

        const json = picker.querySelector(
          'script[type="application/json"]'
        );

        if (!json) return;


        let variants = [];

        try {
          variants = JSON.parse(json.textContent);
        } catch (error) {
          return;
        }


        const availableVariants =
          variants.filter(variant => variant.available);

        if (availableVariants.length < 2) return;


        picker.dataset.egBulkReady = 'true';


        const currency =
          window.Shopify?.currency?.active || 'JPY';


        function formatMoney(value) {

          const amount = Number(value) / 100;

          return new Intl.NumberFormat(
            'ja-JP',
            {
              style: 'currency',
              currency: currency,
              maximumFractionDigits:
                currency === 'JPY' ? 0 : 2
            }
          ).format(amount);

        }


        const bulk = document.createElement('details');

        bulk.className = 'eg-bulk-order';


        const rows = variants.map((variant) => {

          const unavailable =
            !variant.available;

          return `
            <div
              class="eg-bulk-order__row
              ${unavailable ? 'is-unavailable' : ''}"
              data-eg-bulk-row
              data-variant-id="${variant.id}"
              data-price="${variant.price}"
            >

              <div class="eg-bulk-order__info">

                <strong class="eg-bulk-order__variant-title">
                  ${escapeHTML(variant.title)}
                </strong>

                <span class="eg-bulk-order__price">
                  ${formatMoney(variant.price)}
                </span>

              </div>


              ${
                unavailable
                  ? `
                    <span class="eg-bulk-order__soldout">
                      売り切れ
                    </span>
                  `
                  : `
                    <div class="eg-bulk-order__quantity">

                      <button
                        type="button"
                        data-eg-bulk-minus
                        aria-label="数量を減らす"
                      >
                        −
                      </button>

                      <input
                        type="number"
                        value="0"
                        min="0"
                        inputmode="numeric"
                        data-eg-bulk-qty
                      >

                      <button
                        type="button"
                        data-eg-bulk-plus
                        aria-label="数量を増やす"
                      >
                        +
                      </button>

                    </div>
                  `
              }

            </div>
          `;

        }).join('');


        bulk.innerHTML = `

          <summary class="eg-bulk-order__summary">

            <div>

              <strong>
                複数カラー・サイズをまとめて購入
              </strong>

              <span>
                ワークショップ・教室でのご注文に便利です
              </span>

            </div>

          </summary>


          <div class="eg-bulk-order__body">

            <p class="eg-bulk-order__intro">
              ご希望の商品ごとに数量を入力し、
              一度にまとめてカートへ追加できます。
            </p>


            <div class="eg-bulk-order__list">

              ${rows}

            </div>


            <div class="eg-bulk-order__totals">

              <div>
                選択数
                <strong data-eg-bulk-count>
                  0
                </strong>
                点
              </div>

              <div>
                合計
                <strong data-eg-bulk-total>
                  ${formatMoney(0)}
                </strong>
              </div>

            </div>


            <button
              type="button"
              class="eg-bulk-order__add"
              data-eg-bulk-add
            >
              選択した商品をまとめてカートに追加
            </button>


            <div
              class="eg-bulk-order__message"
              data-eg-bulk-message
            ></div>

          </div>
        `;


        const summary =
          picker.parentElement?.querySelector(
            '.eg-variant-summary'
          );


        if (summary) {

          summary.insertAdjacentElement(
            'afterend',
            bulk
          );

        } else {

          picker.insertAdjacentElement(
            'afterend',
            bulk
          );

        }


        const qtyInputs =
          bulk.querySelectorAll(
            '[data-eg-bulk-qty]'
          );

        const countElement =
          bulk.querySelector(
            '[data-eg-bulk-count]'
          );

        const totalElement =
          bulk.querySelector(
            '[data-eg-bulk-total]'
          );

        const addButton =
          bulk.querySelector(
            '[data-eg-bulk-add]'
          );

        const message =
          bulk.querySelector(
            '[data-eg-bulk-message]'
          );


        function normalizeQuantity(input) {

          let value =
            parseInt(input.value, 10);

          if (
            Number.isNaN(value) ||
            value < 0
          ) {
            value = 0;
          }

          input.value = value;

          return value;

        }


        function updateTotals() {

          let count = 0;
          let total = 0;


          qtyInputs.forEach((input) => {

            const quantity =
              normalizeQuantity(input);

            const row =
              input.closest(
                '[data-eg-bulk-row]'
              );

            const price =
              Number(
                row.dataset.price
              );


            count += quantity;

            total +=
              quantity * price;

          });


          countElement.textContent =
            count;

          totalElement.textContent =
            formatMoney(total);


          addButton.disabled =
            count === 0;

        }


        bulk
          .querySelectorAll(
            '[data-eg-bulk-plus]'
          )
          .forEach((button) => {

            button.addEventListener(
              'click',
              () => {

                const row =
                  button.closest(
                    '[data-eg-bulk-row]'
                  );

                const input =
                  row.querySelector(
                    '[data-eg-bulk-qty]'
                  );

                input.value =
                  normalizeQuantity(input) + 1;

                updateTotals();

              }
            );

          });


        bulk
          .querySelectorAll(
            '[data-eg-bulk-minus]'
          )
          .forEach((button) => {

            button.addEventListener(
              'click',
              () => {

                const row =
                  button.closest(
                    '[data-eg-bulk-row]'
                  );

                const input =
                  row.querySelector(
                    '[data-eg-bulk-qty]'
                  );

                input.value =
                  Math.max(
                    0,
                    normalizeQuantity(input) - 1
                  );

                updateTotals();

              }
            );

          });


        qtyInputs.forEach((input) => {

          input.addEventListener(
            'input',
            updateTotals
          );

          input.addEventListener(
            'change',
            updateTotals
          );

        });


        addButton.addEventListener(
          'click',
          async () => {

            const items = [];


            qtyInputs.forEach((input) => {

              const quantity =
                normalizeQuantity(input);

              if (quantity < 1) return;


              const row =
                input.closest(
                  '[data-eg-bulk-row]'
                );


              items.push({
                id: Number(
                  row.dataset.variantId
                ),
                quantity: quantity
              });

            });


            if (!items.length) {

              message.textContent =
                '数量を選択してください。';

              return;
            }


            addButton.disabled = true;

            addButton.textContent =
              'カートに追加しています…';

            message.textContent = '';


            const root =
              window.Shopify?.routes?.root ||
              '/';


            try {

              const response =
                await fetch(
                  `${root}cart/add.js`,
                  {
                    method: 'POST',

                    credentials:
                      'same-origin',

                    headers: {
                      'Content-Type':
                        'application/json',

                      'Accept':
                        'application/json'
                    },

                    body: JSON.stringify({
                      items: items
                    })
                  }
                );


              if (!response.ok) {

                const error =
                  await response.json();

                throw new Error(
                  error.description ||
                  'Cart error'
                );

              }


              window.location.href =
                `${root}cart`;


            } catch (error) {

              message.textContent =
                error.message ||
                'カートへの追加に失敗しました。数量をご確認ください。';


              addButton.disabled = false;

              addButton.textContent =
                '選択した商品をまとめてカートに追加';

            }

          }
        );


        updateTotals();

      });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initBulkOrder
  );


  document.addEventListener(
    'shopify:section:load',
    initBulkOrder
  );


  const observer =
    new MutationObserver(
      initBulkOrder
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();